import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { settingsReducer } from './store/settings.reducer';
import { SettingsEffects } from './store/settings.effects';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
    imports: [
        StoreModule.forFeature('settings', settingsReducer),
        EffectsModule.forFeature([SettingsEffects]),
        OverlayModule
    ],
    declarations: []
})
export class SettingsModule { }
